import { Component, Input, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import moment from 'moment';

@Component({
  selector: 'app-short-cancellation-policy',
  templateUrl: './short-cancellation-policy.component.html',
  styleUrls: ['./short-cancellation-policy.component.scss']
})
export class ShortCancellationPolicyComponent {
 @Input() cancelPolicies: any;
  @Input() checkInDate: string;
  timeZone: string = '';

  constructor(){}

  ngOnInit() {
    if(this.cancelPolicies){
      this.getTimezoneFromPolicies();
      this.convert3rdPolicy();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.cancelPolicies){
      this.getTimezoneFromPolicies();
      this.convert3rdPolicy();
    }
  }

  convert3rdPolicy(){
    if (this.cancelPolicies.length === 2) {
      const [first, second] = this.cancelPolicies;
    
      const isFirstItemMatch = first.from_day === null && first.to_day === 0;
      const isSecondItemMatch = second.from_day === 0 && second.to_day === 0;
    
      if (isFirstItemMatch && isSecondItemMatch) {
        this.cancelPolicies = [second]; // Giữ lại item 2
      }
    }
  }

  getDateBefore(daysAgo: number, baseDate: string): string {
    return moment(baseDate).subtract(daysAgo, 'days').format('YYYY-MM-DD');
  }
  
  getTimezoneFromPolicies() {
    const policyWithTime = this.cancelPolicies.find((p: { time: any; }) => p.time);
    if (!policyWithTime) return;
  
    const timeStr = policyWithTime.time;
    const match = timeStr.match(/([+-])(\d{2}):?(\d{2})?/);
  
    if (!match) return;
  
    const sign = match[1] === '+' ? '+' : '-';
    const hours = parseInt(match[2], 10);
  
    this.timeZone = `(UTC${sign}${hours})`;
  }

  inRangeDate(from: number | null, to: number): boolean {
    // Validate checkInDate
    if (!this.checkInDate || isNaN(new Date(this.checkInDate).getTime())) {
        console.error('Invalid checkInDate');
        return false;
    }

    // Parse checkInDate to a Date object
    const checkIn = new Date(this.checkInDate);
    
    // Get current date
    const currentDate = new Date();
    
    // Handle from being null (set to 1 year before checkInDate)
    const fromDays = from !== null ? from : -365;
    
    // Calculate the range boundaries
    const fromDate = new Date(checkIn);
    fromDate.setDate(checkIn.getDate() + fromDays);
    
    const toDate = new Date(checkIn);
    toDate.setDate(checkIn.getDate() + to);
    
    // Normalize dates to remove time components for accurate comparison
    currentDate.setHours(0, 0, 0, 0);
    fromDate.setHours(0, 0, 0, 0);
    toDate.setHours(0, 0, 0, 0);
    
    // Check if current date is within the range (inclusive)
    return currentDate >= fromDate && currentDate <= toDate;
  }
}
